module.exports = "/_next/static/images/icon_bundle_9-a36ad5f8a6abc8a256231648dfcbc98a.png";